module.exports = __webpack_public_path__ + "static/media/eth.18708d3e.svg";